import { Component, OnInit, Inject } from '@angular/core';
import { EscritoriosService, DominiosService, UsuarioService, RelatorioService } from '../shared/services/acordo-ressarcimento/api/services';
import { Observable, of } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LoadingService } from '../shared/services/components/loading.service';
import { AppComponent } from '../app.component';
import { ProcedenciaAcordo, SituacaoAcordo } from '../shared/services/acordo-ressarcimento/api/models';
import * as moment from 'moment';

@Component({
  selector: 'app-relatorio-acordo',
  templateUrl: './relatorio-acordo.component.html',
  styleUrls: ['./relatorio-acordo.component.css']
})

export class RelatorioAcordoComponent implements OnInit {
  public procedenciasAcordo: ProcedenciaAcordo[];
  public formPesquisa: FormGroup;
  public listaEscritoriosFiltro: any[];
  public nomeEscritorioFiltro: any[];
  public selected = '';
  public codigoEscritorio: number;
  public nomeEscritorio: string;
  public isEscritorio: boolean;
  public situacoesAcordo: SituacaoAcordo[];
  public dataLimiteSelecao: String;
  public escritorio: any;

  constructor(
    private formBuilder: FormBuilder,
    public relatorioService: RelatorioService,
    public escritorioService: EscritoriosService,
    private loading: LoadingService,
    public dominiosService: DominiosService,
    public usuarioService: UsuarioService,
    @Inject(AppComponent) public appComponent: AppComponent) { }

  public ngOnInit() {
    this.carregarTiposSituacoesAcordo();
    this.criarFormPesquisa();
    this.carregarDadosPagina();

  }

  carregarDadosPagina() {
    this.usuarioService.recuperarDadosUsuario().subscribe(result => {
      this.formPesquisa.controls['ramoSinistro'].setValue(result.produto);

      if (result.codigoEscritorio) {
        this.codigoEscritorio = result.codigoEscritorio;
      }

      if (result.nomeEscritorio) {
        this.nomeEscritorio = result.nomeEscritorio;
      }

      this.isEscritorio = result.flagEscritorio;
    });
  }

  private criarFormPesquisa() {
    this.formPesquisa = this.formBuilder.group({
      ramoSinistro: null,
      dataDe: null,
      dataAte: { disabled: true, value: '' },
      statusAcordo: null,
      escritorio: this.nomeEscritorio != null ? this.nomeEscritorio : null,
      codigoEscritorio: this.codigoEscritorio != null ? this.codigoEscritorio : null,
    });
  }

  private validarFormulario(): boolean {
    var isValido = true;

    if (this.formPesquisa.value['dataDe'] == null || this.formPesquisa.value['dataDe'] == "") {
      isValido = false;
      this.formPesquisa.controls['dataDe'].setErrors({ 'incorrect': true });
    }

    if (this.formPesquisa.value['dataAte'] == null || this.formPesquisa.value['dataAte'] == "") {
      isValido = false;
      this.formPesquisa.controls['dataAte'].setErrors({ 'incorrect': true });
    }

    return isValido;
  }

  public autoCompleteBuscaEscritorio() {
    return (keyword: any): Observable<any> => {
      this.nomeEscritorioFiltro = [];

      var parametros: EscritoriosService.ObterEscritoriosParams = {
        nomeEscritorio: this.formPesquisa.controls['escritorio'].value,
        codigoRamoSinistro: this.appComponent.codigoRamo
      };

      this.escritorioService.obterEscritorios(parametros).subscribe(
        data => {
          this.listaEscritoriosFiltro = data;
          for (let key in data) {
            this.nomeEscritorioFiltro.push(data[key].nomeEscritorio);
          }
        }
      );
      return of(this.nomeEscritorioFiltro);
    };
  }

  public autoCompleteBuscaEscritorioSelected($event) {
    this.selected = $event;
    for (let key in this.listaEscritoriosFiltro) {
      if (this.listaEscritoriosFiltro[key].nomeEscritorio == this.selected) {
        this.formPesquisa.controls['codigoEscritorio'].setValue(this.listaEscritoriosFiltro[key].codigoEscritorio);
      }
    }
  }

  public gerarRelatorioAcordo() {
    if (this.validarFormulario()) {
      this.loading.open();

      if (this.tratarCondicao(this.escritorio) == null && this.isEscritorio === false) {
        this.formPesquisa.controls['codigoEscritorio'].setValue(null);
      }

      var parametros: RelatorioService.ObterRelatorioAcordoParams = {
        ramoSinistro: this.tratarCondicao(this.formPesquisa.value['ramoSinistro']),
        periodoInicial: this.tratarCondicao(this.formPesquisa.value['dataDe']),
        periodoFinal: this.tratarCondicao(this.formPesquisa.value['dataAte']),
        codigoStatus: this.tratarCondicao(this.formPesquisa.value['statusAcordo']),
        codigoEscritorio: this.tratarCondicao(this.formPesquisa.value['codigoEscritorio'])
      };

      this.relatorioService.obterRelatorioAcordo(parametros).subscribe(response => {
        if (response) {
          const blob = new Blob([response], { type: 'application/vnd.ms-excel' });
          const url = window.URL.createObjectURL(blob);
          window.open(url);
          this.appComponent.createAlert('Relatório emitido com sucesso.', 'success');
        }
        this.loading.close();
      }, error => {
        this.appComponent.createAlert('Não foi possível gerar o relatório.', 'error');
        this.loading.close();
      });
    } else {
      return;
    }
  }

  public calculaDataMaximaSelecao($event) {
    this.formPesquisa.controls['dataAte'].setValue(null);

    var dataLimite = new Date(moment($event, "DD/MM/YYYY").format("YYYY-MM-DD"));
    dataLimite.setDate(dataLimite.getDate() + 91);

    this.dataLimiteSelecao = moment(dataLimite, "DD/MM/YYYY").format("DD/MM/YYYY");

    this.formPesquisa.controls['dataAte'].enable();
  }

  private carregarTiposSituacoesAcordo(): void {
    this.dominiosService.obterTiposSituacaoAcordo().subscribe(result => {
      this.situacoesAcordo = result;
    });
  }

  public limparPesquisa() {
    this.ngOnInit();
  }

  public log(event) {
    console.log(event);
  }

  public tratarCondicao(valor: any) {
    if (valor !== undefined && valor !== null && valor === '') {
      return null;
    }
    return valor;
  }

}
